import React from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { getConfig } from "../../loadconfig";
import OfficeTimings from "./OfficeTimings";
import ViewProviderEcpIndicatorDetails from "./ViewProviderEcpIndicatorDetails";
import ViewProviderHandicapAccessible from "./ViewProviderHandicapAccessible";
import ViewProviderInterpreterService from "./ViewProviderInterpreterService";
import ViewProviderAcceptPatient from "./ViewProviderAcceptPatient";
import { formatPracticeUrlWithHttp } from "../../utils/URLFormat";

const ProviderDetailsRight = ({ officeList, everydays }) => {
  const { t } = useTranslation();
  let config = getConfig();
  const formatPhoneNumber = (value) => {
    const cleaned = ("" + value).replace(/\D/g, "");
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return `${match[1]}-${match[2]}-${match[3]}`;
    }
    return value;
  };

  return (
    <div className="details-right-content">
      <div className="details-location">{t(`officelocations`)} </div>
      <div className="right-sub-content">
        {officeList?.office?.length > 0 &&
          officeList?.office?.map((office, indexMain) => (
            <div key={indexMain} className="box-end">
              <div className="details-flex">
                <div className="detailsLeft">
                  <div>{office?.address?.domesticAddress?.addressLine1}</div>
                  <div>{office?.address?.domesticAddress?.addressLine2}</div>

                  <div>
                    {office?.address?.domesticAddress?.city},{" "}
                    {office?.address?.domesticAddress?.state?.stateAbbreviation}
                    &nbsp;
                    {office?.address?.domesticAddress?.zipcode}
                  </div>

                  {office?.phoneList?.phone?.length > 0 &&
                    office?.phoneList?.phone?.map((phoneVal, index1) => (
                      <div key={index1}>
                        {" "}
                        <a
                          href={`tel:${phoneVal?.phoneNumber}`}
                          className="results-link"
                        >
                          {phoneVal?.phoneNumber !== null &&
                            formatPhoneNumber(phoneVal?.phoneNumber)}
                        </a>
                      </div>
                    ))}
                  <div
                    style={{
                      marginTop: "10px",
                      marginBottom: "10px",
                    }}
                  >
                    {" "}
                    <a
                      href={`${config.GOOGLEMAPLOCURL}${office?.address?.domesticAddress?.addressLine1},${office?.address?.domesticAddress?.addressLine2},${office?.address?.domesticAddress?.city}, ${office?.address?.domesticAddress?.state?.stateAbbreviation},${office?.address?.domesticAddress?.zipcode}`}
                      target="_blank"
                      className="results-link"
                      rel="noreferrer"
                    >
                      {" "}
                      {t(`mapLocation`)}
                    </a>
                  </div>
                </div>

                <div className="detailsRight">
                  <div className="timeflex">
                    <div>
                      <OfficeTimings
                        officeHoursData={office?.officeHoursList?.officeHours}
                        everydays={everydays}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <>
                {
                  office?.practice?.practiceUrl && (
                    <div>
                      <a href={formatPracticeUrlWithHttp(office)}
                        className="results-link detailsLeft"
                        target="_blank"
                        rel="noreferrer">{office.practice.practiceUrl}</a>
                    </div>
                  )}
              </>

              <div
                style={{
                  marginTop: "2rem",
                  marginBottom: "1rem",
                  fontSize: "14px",
                  lineHeight: "1.5",
                }}
              >
                <div>
                  {(() => {
                    const specialtyList =
                      office?.specialtyList?.specialty || [];
                    const allServiceNames = Array.from(
                      new Set(
                        specialtyList
                          .flatMap(
                            (specialty) =>
                              specialty?.serviceList?.service?.map(
                                (service) => service.serviceName
                              ) || []
                          )
                          .filter(Boolean)
                      )
                    ).join(", ");

                    return (
                      <div>
                        {allServiceNames && (
                          <div>
                            <span className="details-subheader">
                              {t("services")}
                            </span>{" "}
                            {allServiceNames}
                          </div>
                        )}
                      </div>
                    );
                  })()}
                </div>
                <div key={indexMain}>
                  <ViewProviderHandicapAccessible office={office} />
                </div>

                {office?.acceptsNewPatient !== null &&
                  office?.acceptsNewPatient !== "" &&
                  office?.acceptsNewPatient !== undefined && (
                    <ViewProviderAcceptPatient office={office} />
                  )}

                <div>
                  {office?.practice !== null && (
                    <div>
                      {office?.practice !== null && (
                        <span className="details-subheader">
                          {t(`practiceName`)}{" "}
                        </span>
                      )}
                      {office?.practice !== null && (
                        <span style={{ color: "#000" }}>
                          {" "}
                          {office?.practice?.practiceName}
                        </span>
                      )}
                    </div>
                  )}
                </div>

                <div>
                  {office?.languageList?.language?.length > 0 && (
                    <span className="details-subheader">
                      {t(`officeStaffLang`)}
                    </span>
                  )}

                  {office?.languageList?.language?.length > 0 &&
                    office?.languageList?.language?.map((lang, indexLang) => (
                      <span key={indexLang}>
                        {lang?.languageName !== null && (
                          <span style={{ color: "#000" }}>
                            &nbsp;{lang?.languageName}
                            {indexLang <
                              office?.languageList?.language?.length - 1
                              ? ", "
                              : ""}
                          </span>
                        )}
                      </span>
                    ))}
                </div>

                <div>
                  <ViewProviderInterpreterService office={office} />
                </div>

                <div>
                  <ViewProviderEcpIndicatorDetails office={office} />
                </div>

                <div>
                {office?.telemedicine && (
                          <div>
                          <span className="details-subheader">
                            {t("telemedicineIndicator")}:{" "}
                          </span>
                          <span style={{ color: "#000" }}>
                            {t(office?.telemedicine)}
                          </span>
                        </div>
                          
                        )}
                        </div>

                        <div>
                        {office?.remotecaregiverliaison && (
                          <div>
                          <span className="details-subheader">
                            {t("remoteCareGiverLiaison")}:{" "}
                          </span>
                          <span style={{ color: "#000" }}>
                            {t(office?.remotecaregiverliaison)}
                          </span>
                        </div>
                          
                        )} 
                        </div>


                        <div>{office?.officeTelemedModalitiesList?.officeTelemedModality?.length > 0 && (
                          <span className="details-subheader">
                            {t("Modalities")}:{" "}
                          </span>
                        )}
                          {office?.officeTelemedModalitiesList?.officeTelemedModality?.map((modality, indexMod) => (

                            <span style={{ color: "#000" }} key={indexMod}>
                              {t(modality?.code)}
                              {indexMod < office?.officeTelemedModalitiesList?.officeTelemedModality?.length - 1 ? ", " : ""}


                            </span>

                          ))}
                        </div>
                <div>
                  {
                    office?.referralRequired && (
                      <>
                        <span className="details-subheader">
                          {t("ReferralRequired")}:{" "}
                        </span>
                        <span style={{ color: "#000" }}>
                          {t(office?.referralRequired)}
                        </span>
                      </>                      
                    )
                  }
                </div>
                <div>
                  {
                    office?.populationServedAgesList?.populationServedAge && office?.populationServedAgesList?.populationServedAge.length > 0 && (
                      <><span className="details-subheader">
                        {t("populationServedAge")}:{" "}
                      </span>
                        {
                          office?.populationServedAgesList?.populationServedAge.map((age, index) => (
                            <span style={{ color: "#000" }} key={index}>
                              {t(age?.desc)}
                              {index < office?.populationServedAgesList?.populationServedAge?.length - 1 ? ", " : ""}
                            </span>
                          ))
                        }</>
                    )
                  }
                </div>
                <div>
                  {
                    office?.populationServedGendersList?.populationServedGender && office?.populationServedGendersList?.populationServedGender.length > 0 && (
                      <><span className="details-subheader">
                        {t("populationServedGender")}:{" "}
                      </span>
                        {
                          office?.populationServedGendersList?.populationServedGender.map((gender, index) => (
                            <span style={{ color: "#000" }} key={index}>
                              {t(gender?.desc)}
                              {index < office?.populationServedGendersList?.populationServedGender.length - 1 ? ", " : ""}
                            </span>
                          ))
                        }</>
                    )
                  }
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

ProviderDetailsRight.propTypes = {
  officeList: PropTypes.object,
  everydays: PropTypes.array,
  isTelemedicine: PropTypes.boolean,
  telemedModalities: PropTypes.string,
  telemedCaregiverAccess: PropTypes.string,
  languageData: PropTypes.string,
  referralRequired: PropTypes.string,
  populationServedAges: PropTypes.array,
  populationServedGenders: PropTypes.array,
};

export default ProviderDetailsRight;
